export default __webpack_public_path__ + "static/geek-station-logo-only-f00f9a46c2580772f7d8818f95a1cd53.png";